module.exports = __webpack_public_path__ + "img/back.858c51f2.svg";